import { render } from "./commentiModal.vue?vue&type=template&id=13c90b47&ts=true"
import script from "./commentiModal.vue?vue&type=script&lang=ts"
export * from "./commentiModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__